import React, { useContext, useState } from "react";
import Loading from "../../Loading";
import HtDate from "../../components/HtDate";
import HtTabs from "../../components/HtTabs";
import useDBO from "../../hooks/useDBO";
import Error from "../../components/Error";
import { CenterContext } from "../../../../Context";
import ClassView from "../attendance/components/ClassView";
import SLink from "../../components/SLink";
import Lang from "../../components/Lang";
import { Button, CircularProgress } from "@mui/material";
import mut from "../../hooks/mut";


export default function ManageFeedback() {

  const { locations } = useContext(CenterContext)
  const [fbDate, setFbDate] = useState(new Date().addDays(-1));
  const components = [
    <DrawLocation
      location={locations[0]._id}
      fbDate={fbDate}
    />,
    <DrawLocation
      location={locations[1]._id}
      fbDate={fbDate}
    />,
  ];

  return (
      <HtTabs
        labels={locations.map((l) => l.name)}
        components={components}
        nextToTabs={
          <HtDate
            value={fbDate}
            setValue={setFbDate}
          />
        }
      />
  );
}

function DrawLocation({ location, fbDate }) {
  const lessons = useDBO(`/feedback-by-date/${location}/${fbDate.tDate()}`, 60);
  const [reviewing,setReviewing] = useState(false)
  const [lesson, setLesson] = useState(undefined)
    const { center } = useContext(CenterContext);
   if (lessons.loading) return <Loading />;
  if (lessons.error) return <Error />;
  


 
  return (
    <div>
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {lessons.map((l) => (
          <div onClick={() => setLesson(l)}>
            <ClassView
              htClass={l}
              setSelected={() => {
                return;
              }}
            />
          </div>
        ))}
      </div>
      <br />
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>Feedback</div>
        {lesson && lesson.aiReviewed && (
          <AiAverage feedback={lesson.feedbacks} />
        )}
        {(lesson && !lesson.aiReviewed) && <div>
          <div>
            {reviewing ? (
              <div>
                Reviewing by the AI{" "}
                <CircularProgress
                  color="primary"
                  size={10}
                />
              </div>
            ) : (
              <Button
                onClick={async () => {
                  setReviewing(true);
                  let res = await mut(
                    "post",
                    `/lesson-review-feedback-ai/${lesson._id}`
                  );
                    if (res.error) {
                      setReviewing(false)
                      alert("Could not complete AI review, try again later (please wait at least 5 minutes")
                      return
                    }
                  setLesson(res);
                  lessons.update(res);
                  setReviewing(false);
                }}
                disabled={lesson && lesson.aiReviewed}
              >
                Review with AI
              </Button>
            )}
          </div>
        </div>}
      </div>
      {lesson && (
        <table
          style={{
            border: "1px solid #ccc",
            width: "100%",
            fontSize: 14,
            borderCollapse: "collapse",
            borderRadius: 10,
          }}
        >
          <tr
            style={{
              border: "1px solid #ccc",
              background: "#ccc",
            }}
          >
            <th style={{}}>
              <Lang w="name" />
            </th>
            <th>
              <Lang w="notes" />
            </th>
            <th>
              <Lang w="homeworkNotes" />
            </th>
            {center.feedbackCategories.map((c) => (
              <th key={c}>{c}</th>
            ))}
          </tr>
          {lesson.feedbacks
            .filter((f) => f.attendance < 2)
            .map((f) => (
              <DrawFeedback
                key={f._id}
                feedback={f}
                categories={center.feedbackCategories}
                ai={lesson.aiReviewed}
              />
            ))}
        </table>
      )}
    </div>
  );
}

function AiAverage({ feedback }) {
  
 const average=getAverage(feedback)
  return (
    <div style={{display:"flex",gap:5}}>
      <div>Ai score</div>
      <div style={{color: getColor(average)}}>{average}</div>
    </div>
  );
}

function getAverage(feedback) {
   let scores = feedback.map((f) => f.aiScore);
   let sum = scores.reduce((a, b) => a + b, 0);
   if (scores.length === 0) return <>0</>;
  const average = (10 / (scores.length * 10)) * sum;
  return average.toFixed(1);
}

function DrawFeedback({ feedback, categories, ai }) {
  
  const cellStyle = { border: "1px solid #ccc", padding: 5 }
  

  return (
    <tr>
      <td style={cellStyle}>
        <SLink id={feedback.student} />
      </td>
      <td style={cellStyle}>
        <div>{feedback.notes}</div>
        {ai && <AIFeedback feedback={feedback}/>}
      </td>
      <td style={cellStyle}>{feedback.homeworkNotes}</td>
      {categories.map((c) => (
        <td
          align="center"
          style={cellStyle}
        >
          {feedback.feedback && feedback.feedback[c]
            ? feedback.feedback[c]
            : ""}
        </td>
      ))}
    </tr>
  );
}

function AIFeedback({ feedback }) {

  let color = getColor(feedback.aiScore)


  return (
    <div>
      <hr />
      <div style={{display:"flex", justifyContent: "space-between"}}>
        <div >AI review</div>
        <div>Score: {feedback.aiScore}</div>
      </div>
      <div style={{ color }}>{feedback.aiComment}</div>
    </div>
  );
}

function getColor(score) {
  let color = "green";
  if (score < 7) color = "goldenrod";
  if (score < 5) color = "red";
  return color
}